import React from 'react';
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../hooks";

import Header from './Header';

import '../../styles/global.css';

export default function Layout() {
    const user = useAppSelector((state) => state.user);

    return user.id !== 0 ? (
        <>
            <Header />
            <main>
                <Outlet />
            </main>
        </>
    ) : ( 
        <Navigate to="/" />
    );
}
